import http from '../http/http';

import { generateEndpoint, PROPERTY_DETACHMENTS } from '../http/endpoints';

export default (() => {
    const getAll = () => http.get(generateEndpoint(PROPERTY_DETACHMENTS));

    return {
        getAll,
    };
})();
